import React from 'react';
let Loader = props => {
    return <div className="container-fluid mb-5 h-100  text-center loading-screen"><i className="fa fa-circle-o-notch fa-spin" ></i></div>;
}


export default Loader;